import React from 'react';
export function Footer() {
  return <footer className="bg-[#111111] text-[#666666] text-center py-5 sm:py-7 px-5 text-[12px] leading-[1.8]" data-id="element-127">
      <div className="text-[15px] font-bold text-[#CCCCCC] mb-2" data-id="element-128">
        🌸 KIT PROFESIONAL DE IMAGEN Y GESTIÓN PARA ESTETICISTAS™
      </div>
      <div data-id="element-129">
        El sistema de gestión N°1 para esteticistas, cosmiatras y cosmetólogas
        en Argentina.
      </div>
      <div data-id="element-130">Porque tu negocio merece verse tan bien como lo que hacés.</div>
      <div className="mt-3" data-id="element-131">
        <a href="#" className="text-[#888888] hover:text-white transition-colors" data-id="element-132">
          contacto@solucionesya.shop
        </a>{' '}
        ·{' '}
        <a href="#" className="text-[#888888] hover:text-white transition-colors" data-id="element-133">
          @solucionesya.shop
        </a>{' '}
        ·{' '}
        <a href="#" className="text-[#888888] hover:text-white transition-colors" data-id="element-134">
          solucionesya.shop
        </a>
      </div>
      <div className="mt-2" data-id="element-135">
        © Solucionesya.shop™ 2026 — Todos los derechos reservados.
      </div>
    </footer>;
}